























































import { Component, Vue } from 'vue-property-decorator';
import NationCasesTable from '@/components/NationCasesTable.vue';
import DisplayControls from '@/components/DisplayControls.vue';
import FullWidthStateSelector from '@/components/FullWidthStateSelector.vue';
import MapSelector from '@/components/MapSelector.vue';
import Objective from '@/components/Objective.vue';

import { BIconCaretRightFill, BIconCaretLeftFill, BIconArrowRightCircleFill, BIconArrowLeftCircleFill } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import { mapState } from 'vuex'

@Component({
  components: {
      NationCasesTable,
      BIconCaretRightFill, 
      BIconCaretLeftFill,
      BIconArrowRightCircleFill, 
      BIconArrowLeftCircleFill,
      FullWidthStateSelector,
      DisplayControls,
      MapSelector,
      Objective
  },
  computed: {
        ...mapState(['displayOutput', 'nationCasesAverted', 'nationDeathsAverted','nationDataArray'])
    },
  created() {
    this.$store.dispatch("setRoute", "nation");
  },
  mounted() {
    this.$store.dispatch('drawNation');
    this.$store.dispatch("setHref", this.$router.currentRoute.path);
  }
})
export default class Nation extends Vue {}
